import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map } from 'rxjs';

// Uses isAuthenticated$ instead of the authenticated() signal so the guard waits
// for the startup checkAuth() call to finish before deciding on hard refreshes.
export const authGuard: CanActivateFn = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    map(({ isAuthenticated }) => isAuthenticated || router.createUrlTree(['/login'])),
  );
};
